import React, { FunctionComponent, useState, useEffect } from 'react';
import IndicatorsModel from '../models/indicatorsModel';
import IndicatorsService from '../services/indicatorsService';

import { formatDate, formatNumberColor, formatStringColor } from '../helpers/utils';
import { blue, green, red } from '@mui/material/colors';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import StyledTableRow from '../components/StyledTableRowComponent';
import { Accordion, Col, Container, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
import { ArrowCircleDown, ArrowCircleUp, CheckCircle, RemoveCircle } from '@mui/icons-material';
import StatsService from '../services/statsService';
import StatsModel from '../models/statsModel';
import 'bootstrap/dist/css/bootstrap.min.css';

// Définir l'interface des props pour ton composant
interface IndicatorsPageProps extends RouteComponentProps {
  activeTab: string;
}


const IndicatorsPage: FunctionComponent<IndicatorsPageProps> = ({activeTab}) => {
  const [tabIndicators, setTabIndicators] = useState<IndicatorsModel[]>([]);
  const [tabStats, setTabStats] = useState<StatsModel[]>([]);
  const [dateLastScan, setDateLastScan] = useState<Date>();
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  const goToIndicators = (uid: number) => {
    history.push(`/indicators/${uid}`);
  }

  // Fonction pour vérifier si l'image chargée est valide
  const checkImage = (indicators: IndicatorsModel) => {
    const img = new Image();
    img.src = indicators.url + "/favicon.ico";
    img.onload = () => {
      indicators.imgIsValid = true;
    };
    img.onerror = () => {
      indicators.imgIsValid = false;
    };
  };


  useEffect(() => {
    setIsLoading(true);
    IndicatorsService.getIndicators()
      .then(tabIndicators => {
        tabIndicators && tabIndicators.map((indicators) => (
          checkImage(indicators)
        ))
        setDateLastScan(tabIndicators[0].date);
        setTabIndicators(tabIndicators);
        //console.log(tabIndicators)
      })
      .finally(() => { setIsLoading(false); })
    
    StatsService.getStats()
      .then(tabStats => {
        setTabStats(tabStats);
      })
      .finally(() => { setIsLoading(false); })
  }, []);

  return (
    <Container fluid className="py-4 px-3">
      <h1>Tableau de bord</h1>
      <p><small>Le Dashlord France Travail est 100% open source. Il compile les données techniques (résultats de scanner) issues de différents outils open source (principalement des API). <br/>
      Les mesures sont effectuées quotidiennement {dateLastScan?`(`+formatDate(dateLastScan)+`)`:''} à partir de la page d'accueil de chaque produit. Un produit est mesurable s'il dispose d'une url dédiée.</small></p>
      {isLoading? <Spinner animation="border" />
      :<Tabs defaultActiveKey={activeTab?activeTab:"tech"} id="tab-indicators">
        <Tab eventKey="tech" title="Données techniques" className="nav-item">
          <Table responsive striped hover borderless>
            <thead>
              <tr>
                <th>Nom du produit</th>
                <th title="Bonnes pratiques de configuration HTTP">HTTP</th>
                <th title="Récupéré via l’API SslLabs ">SSL</th>
                <th title="Ports TCP ouverts détectés par nmap">Ports</th>
                <th title="Nombre de cookies présents">Cookies</th>
                <th title="Présence des mentions légales et conformité de celles-ci">Mentions légales</th>
                <th title="Présence de la politique de confidentialité et conformité de celle-ci">Politique de confidentialité</th>
                <th title="Présence de la page Statistiques">Page statistiques</th>
                <th title="Score basé sur une échelle de 0 à 100">Performance</th>
                <th title="Score basé sur une échelle de 0 à 100. Ne couvre que ~20% des critères du RGAA).">Accessibilité</th>
                <th title="Score calculé via l’API EcoIndex">EcoIndex</th>
              </tr>
            </thead>
            <tbody>
              {tabIndicators && tabIndicators.map((indicators, index) => (
              <tr key={`${indicators.uid}`} style={{ cursor: "pointer", height: "70px" }} onClick={(e) => { e.stopPropagation(); goToIndicators(indicators.uid) }}>
                <th align="right" scope="row"><a href="#">{indicators.name}</a></th>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.httpScore?formatStringColor(indicators.httpScore):'-'}</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.sslScore?formatStringColor(indicators.sslScore):'-'}</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.nbOpenPorts?indicators.nbOpenPorts:'-'}</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.nbCookies?indicators.nbCookies:'-'}</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.isMentionsLegales ?<span aria-hidden="true" className="icon icon-check-round-full"/>:<span aria-hidden="true" className="icon icon-close-round-full"/> }</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.isPolitiqueConfidentialite ?<span aria-hidden="true" className="icon icon-check-round-full"/>:<span aria-hidden="true" className="icon icon-close-round-full"/> }</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.isPageStats ?<span aria-hidden="true" className="icon icon-check-round-full"/>:<span aria-hidden="true" className="icon icon-close-round-full"/> }</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.performanceScore?formatNumberColor(Math.round(indicators.performanceScore)):'-'}</td>
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.accessibilityScore?formatNumberColor(indicators.accessibilityScore):'-'}</td> 
                <td align="center" style={{ borderLeft: "1px solid white" }}>{indicators.ecoIndexScore?formatStringColor(indicators.ecoIndexScore):'-'}</td>
              </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
        <Tab eventKey="stats" title="Référencement des pages statistiques">
          <Table responsive striped hover borderless>
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Nom du produit</th>
                <th style={{ width: "70%" }}>URL</th>
              </tr>
            </thead>
            <tbody>
              {tabStats && tabStats.map((stats, index) => (
              <tr key={`${stats.uid}`}>
                <th align="right" scope="row"><b>{stats.name}</b></th>
                <td align="left" style={{ borderLeft: "1px solid white" }}>{stats.urlStat?<a href={`${stats.urlStat}`} target='_blank' rel='noreferrer'>Accéder à la page</a>:'-'}</td>
              </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
      </Tabs>}
      
      <Row style={{ marginTop: '40px', marginBottom: '10px' }}>
        <Col><h3>Les outils utilisés</h3></Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>API Mozilla</Accordion.Header>
              <Accordion.Body>
                <div>Évalue le niveau de qualité/sécurité de la page web et de son serveur
                <ul>
                  <li>Bonnes pratiques de configuration</li>
                  <li>Bonnes pratiques web</li>
                  <li>Solidité des clés de chiffrement</li>
                </ul></div>
                <a href='https://developer.mozilla.org/en-US/observatory' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Nmap</Accordion.Header>
              <Accordion.Body>
                <p>Nmap scan les vulnérabilités d'une machine (IP) associée à un domaine.<br/>
                Scan des ports ouverts avec vulnérabilités grâce au script vulners.<br/></p>
                <a href='https://nmap.org/' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
      <Row style={{ marginTop: '15px' }}>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>API SSL Labs</Accordion.Header>
              <Accordion.Body>
                <p>Evalue la conformité du certificat SSL utilisé par le protocole HTTPS</p>
                <a href='https://www.ssllabs.com/projects/ssllabs-apis/index.html' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Librairie Pupeteer</Accordion.Header>
              <Accordion.Body>
                <p>Package npm Pupeteer pour simuler le navigateur et récupérer les cookies.</p>
                <a href='https://pptr.dev/' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
      <Row style={{ marginTop: '15px' }}>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Google Lighthouse</Accordion.Header>
              <Accordion.Body>
                <div>Permet un audit automatique de page web :
                <ul>
                  <li>Performances de chargement</li>
                  <li>Bonnes pratiques SEO (référencement)</li>
                  <li>Bonnes pratiques accessibilité (moteur Axe)</li>
                  <li>Bonnes pratiques web</li>
                </ul>
                <br/>
                Les mesures de performance sont un instantané, et donc pas forcément représentatives.<br/>
                Les mesures d'accessibilité n'abordent pas du tout le RGAA.</div>
                <a href='https://developer.chrome.com/docs/lighthouse/overview?hl=fr' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col sm={6}>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>API EcoIndex</Accordion.Header>
              <Accordion.Body>
                <div>EcoIndex green-it est un outil communautaire, gratuit et transparent qui, pour une URL donnée, permet d’évaluer :
                <ul>
                  <li>sa performance environnementale absolue à l’aide d’un score sur 100 (higher is better)</li>
                  <li>sa performance environnementale relative à l’aide d’une note de A à G</li>
                  <li>l’empreinte technique de la page (poids, complexité, etc.)</li>
                  <li>l’empreinte environnementale associée (gaz à effet de serre et eau)</li>
                </ul>
                L’objectif d’EcoIndex est d’aider le plus grand nombre à prendre conscience de l’impact environnemental de l’internet.</div>
                <a href='https://github.com/cnumr/ecoindex_python_fullstack/blob/main/projects/ecoindex_api/README.md' target='_blank' rel='noreferrer'>En savoir plus <span aria-hidden="true" className="icon icon-launch" style={{ marginLeft: '10px'}}></span></a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
}

export default IndicatorsPage;